 <template>
    
  <div id="church-info">
    <!-- success alert -->
    <v-dialog
      v-model="alert"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{'emp._Saved_info_'|translate}}</v-card-title>

        <v-card-text>
         {{'prayers._prayer_saved_'|translate}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="alert = false"
          >
            {{'general._ok_'|translate}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


       <!-- Church Drawer -->
    <v-dialog v-model="showChurchReferral" persistent max-width="400">
         <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-side-icon><v-icon @click="showChurchReferral = false">close</v-icon></v-toolbar-side-icon>

          <v-toolbar-title>{{'emp._add_ref_'|translate}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
       <form @submit.prevent="saveReferrals">
         <v-container>
        <v-flex xs12>
          <v-text-field
           :label="$t('emp._firstname_')"
          type="text"
          v-model="referal.firstName"
          required>
          </v-text-field>
        </v-flex>
        <v-flex xs12>
        <v-text-field
         :label="$t('emp._lastname_')"
          type="text"
          v-model="referal.lastName"
          required
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
         <v-text-field
          :label="$t('emp._postname_')"
          type="text"
          v-model="referal.posteName"
          required
          ></v-text-field>
        </v-flex>
       <v-flex xs12>
         <v-text-field 
                hint="12 345 67 89"
                :label="$t('emp._phone_')"
                active
                suffix="+243"
                type="tel" 
                v-model="referal.phone"
                placeholder="## -### - ## - ##"
                :mask="telephone"
                required
                ></v-text-field>
       </v-flex>
      <v-flex xs12 sm12>
        <v-layout row>
        <br>
        <v-btn color="primary" @click="showChurchReferral = false">  {{'general._close_'|translate}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn type="submit" color="success">  {{'general._save_'|translate}}</v-btn>
        </v-layout>
      </v-flex>
         </v-container>
       </form>
      </v-card>
       </v-flex>
         </v-layout>
    </v-dialog>
    <!-- church dialod end -->
      <v-container fluid grid-list-xl>
    <v-layout wrap align-center>
     <v-toolbar>
     <v-toolbar-title>
       <v-list-tile>
        <v-list-tile-avatar size="50">
               <img v-on:click="photoDialog" style="cursor:pointer" v-bind:src="imageUrl"/>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{form.firstName}} {{form.lastName}}</v-list-tile-title>
                <v-list-tile-sub-title>{{'members._access_code_'|translate}} : {{ this.form.accessCode }}</v-list-tile-sub-title>
              </v-list-tile-content>
       </v-list-tile>
    </v-toolbar-title>
     </v-toolbar>
      <v-card class="mb-5">
  <form @submit.prevent="validateChurchInfo">
          <v-card class="md-layout-item">
            <v-card-title>
            <v-flex xs12 sm6>
             {{'emp._parish_name_'|translate}}
              <v-combobox v-model="form.churchName"
                 name="nom de l'église"
                 :error-messages="errors.collect('nom de l\'église')"
                 v-validate="'required'"
                 id="churchName"
              :items="churchNames"
              solo>
              </v-combobox>
            </v-flex>
  <!--       <v-flex xs12 sm6>
          {{'emp._faithful_qt_'|translate}}
          <v-select
          v-model="form.memberSince"
          name="Fidèle depuis quand"
                :error-messages="errors.collect('Fidèle depuis quand')"
                v-validate="'required'"
          :items="[$t('emp._less_1_yr_'),$t('emp._1_3_yr_'),$t('emp._more_5_yr_')]"
          solo
        ></v-select>
        </v-flex> -->


                      <v-flex xs12 sm6>
            <v-widget :title="$t('general.dates_label')" class="mt-3">
              <div slot="widget-content">
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="date"
                    >
                  <v-text-field
                    slot="activator"
                    :label="$t('general.dates_label')"
                    v-model="form.memberSince"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="form.memberSince" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false">{{'general._cancel_'|translate}}</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog.save(date)">{{'general._ok_'|translate}}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-widget>
              </v-flex>
             <v-flex xs12 sm6>
              <v-text-field
                :label="$t('emp._times_go_church_')"
                type="number"
                min="0"
                name="Combien de fois"
                :error-messages="errors.collect('Combien de fois')"
                v-validate="'required'"
                v-model.number="form.churchAttendance">
              </v-text-field>
             </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
               :label="$t('emp._time_week_')"
              
               type="number" 
               min="0"
               name="Combien d'heures"
                :error-messages="errors.collect('Combien d\'heures')"
                v-validate="'required'"
               v-model.number="form.sermonTimeSpent">
              </v-text-field>
            </v-flex>
                <v-flex xs12 sm6>
           <label id="isreferralReady">{{'emp._family_refer_Church_'|translate}}</label>
                <v-radio-group v-model="form.isreferralReady" row>

                     <v-radio  :label="$t('general._yes_')" v-on:change="showChurchReferral = true, showNoreasonReferral = false" :value="true"></v-radio>
                <v-radio    :label="$t('general._no_')"  v-on:change="showNoreasonReferral = true" :value="false"></v-radio>
                </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
                <label id="isVolunteerReady" for="isVolunteerReady">{{'emp._vol_sc_church_'|translate}}</label>
                <v-radio-group
                name="bénévolat"
                :error-messages="errors.collect('bénévolat')"
                v-validate="'required'"
                v-model="form.isVolunteerReady"
                row>
                  <v-radio  :label="$t('general._yes_')" v-on:change="volunteerCard=true" :value="true"></v-radio>
                <v-radio  :label="$t('general._no_')" v-on:change="volunteerCard=false" :value="false"></v-radio>
             
                </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
                 <v-flex xs12 v-show="showNoreasonReferral">
                 {{'emp._refer_member_fa_church_'|translate}}
             
                <v-textarea name="noReferralReason" v-model="form.noReferralReason" solo></v-textarea>
                <!-- <md-input type="noReferralReason" name="noReferralReason" id="noReferralReason" v-model="form.noReferralReason/> -->
             
            </v-flex>
                <v-flex xs12 v-show="!showNoreasonReferral">
                    <v-data-table
                    :headers="headers"
                    :items="referals"
                    hide-actions
                    class="elevation-1">
                    <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.firstName }} {{ props.item.lastName }}</td>
                    <td class="text-xs-left">{{ props.item.accessCode }}</td>
                    <td class="text-xs-left">{{ props.item.phone }}</td>
                    </template>
                </v-data-table>
                </v-flex>
                </v-flex>
                     <v-flex xs12 sm6>
                <v-flex xs12 v-if="!volunteerCard">
             {{'emp._vol_sc_church_'|translate}}
          <v-select
          v-model="form.noVolunteerReason"
          name="Pas de bénévolat"
                :error-messages="errors.collect('Pas de bénévolat')"
                v-validate="'required'"
          :items="[$t('emp._Personalreason_'),$t('emp._Healthproblem_'),$t('emp._Lackofavailability_'),$t('emp._Lackoftraining_')]"
          solo
           ></v-select>
                </v-flex>
             <v-flex xs12 v-if="volunteerCard" v-show="volunteerCard">
               <v-text-field
            :label="$t('emp._Howmanyhours_')"
            type="number" min="0"
            append-icon="watch"
            v-model.number="form.volunteerTime.amount">
            
             <v-select
              :label="$t('emp._frequency_')"
          
             slot="append-outer"
             style="top: -20px"
              offset-y
             name="fréquence"
                :error-messages="errors.collect('fréquence')"
                v-validate="'required'"
        v-model="form.volunteerTime.frequency"
          :items="[$t('emp._Byday_'),$t('emp._Byweek_'),$t('emp._Bymonth_'),$t('emp._Byyears_')]">
        </v-select>
            </v-text-field>
            
             </v-flex>
                     </v-flex>
            
        </v-card-title>
        <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn type="submit" color="primary">  {{'general._save_'|translate}}</v-btn>
        </v-card-actions>
        </v-card>
        </form>

      </v-card>
    </v-layout>
      </v-container>
        </div>
        </template>
<script>
/* eslint-disable */
import { churches } from "@/api/churches";
import fr from "vee-validate/dist/locale/fr";
import firebase, { functions } from "firebase";
import VeeValidate, { Validator } from "vee-validate";
import { db } from "@/api/firebaseInit";
import { auth } from "@/api/firebaseInit";
Validator.localize("fr", fr);
export default {
  name: "church-info",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      date: null,
        headers: [
          { text: 'Prénom et Nom', value: 'lastName' },
          { text: 'Code d\'accès', value: 'accessCode' },
          { text: 'Telephone', value: 'phone' },
        ],
      telephone: '## - ### - ## -##',
      referals: [],
      alert: false,
      childmenu: false,
      churchNames: churches,
      showNoreasonReferral: true,
      refPhone: null,
      member: null,
      showChurchReferral: false,
      member_id: '',
      // form: {
      //     phone: '',
      //     accessCode: '',
      //     imageUrl: '/static/avatar/avatar.png',
      //     lastName: '',
      //     firstName: '',
      //     churchName: '',
      //     churchAttendance: '',
      //     phone: '',
      //     memberSince: '',
      //     sermonTimeSpent: '',
      //     isreferralReady: '',
      //     noReferralReason: '',
      //     isVolunteerReady: '',
      //     noVolunteerReason: '',
      //     volunteerTime: {
      //       amount: 0,
      //       frequency: ''
      //     }
      // },
      referal: {
          accessCode: '',
          firstName: '',    
          lastName: '',
          posteName: '',
          phone: '',
          referredBy: '',
          referredByPhone: ''
      },
      volunteerCard: false,
    };
  },
  mounted() {
    this.$validator.localize("fr", this.dictionary);
    this.referal.phone = this.form.phone;
     
  },
  computed: {
     form () {
        let form = this.$store.getters.getCurrentMember;
        this.member_id = form.id
        return form
    },
    imageUrl() {
      return this.$store.getters.memberPhoto;
    }
  },
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    childmenu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    form (val) {
      return this.$store.commit('currentMember', val);
    },
  },
  methods: {
    save(dateOfBirth) {
      this.$refs.menu.save(dateOfBirth);
    },
    childsave(dateOfBirth) {
      this.$refs.menu.save(dateOfBirth);
    },
    fetchData () {

         db
      .collection("Census").doc(this.member_id)
      .get()
      .then((doc) => {
        this.form.imageUrl = doc.data().imageUrl,
        this.form.firstName = doc.data().firstName,
        this.form.lastName = doc.data().lastName,
        this.form.accessCode = doc.data().accessCode,
        this.form.phone = doc.data().phone,
        this.form.churchName = doc.data().churchName,
        this.form.memberSince = doc.data().memberSince,
        this.form.churchAttendance = doc.data().churchAttendance,
        this.form.sermonTimeSpent = parseInt(doc.data().sermonTimeSpent),
        this.form.isreferralReady = doc.data().isreferralReady,
        this.form.noReferralReason = doc.data().noReferralReason,
        this.form.isVolunteerReady = doc.data().isVolunteerReady,
        this.form.noVolunteerReason = doc.data().noVolunteerReason,
        this.form.volunteerTime = doc.data().volunteerTime
         if (
          doc.data().volunteerTime === null ||
          doc.data().volunteerTime === undefined
        ) {
          this.form.volunteerTime.amount = 0;
          this.form.volunteerTime.frequency = 'Par jour';
        }
      })

       if (doc.data().isVolunteerReady == false) {
         member.volunteerTime.amount = 0;
         member.volunteerTime.frequency = 'Par mois';
       }

       if (doc.data().isreferralReady == false) {
         member.noReferralReason = 'Pas de références';
       }

    },
    validateChurchInfo() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.form.isVolunteerReady === false) {
         this.form.volunteerTime.amount = 0;
         this.form.volunteerTime.frequency = 'Par mois';
       } else {
         if(this.form.isVolunteerReady === true) {
           this.form.noVolunteerReason = 'Pas de raisons'
         }
       }

       if (this.form.isreferralReady == false) {
         this.form.noReferralReason = 'Pas de références';
       }
          this.saveChurchInfo();
        } else {
          return;
        }
      });
    },
     saveReferrals() {
      var memberRef = db.collection("Referrals").doc();
      var refKey = memberRef.id;
      this.referal.accessCode = refKey.substring(0, 5);
      this.referal = {
          accessCode: this.referal.accessCode,
          firstName: this.referal.firstName,
          lastName: this.referal.lastName,
          posteName: this.referal.posteName,
          phone: this.referal.phone,
          referredBy: this.referal.referredBy,
          referredByPhone: this.referal.referredByPhone
      };
        memberRef.set({
          accessCode: this.referal.accessCode,
          firstName: this.referal.lastName,
          lastName: this.referal.firstName,
          posteName: this.referal.posteName,
          phone: this.referal.phone,
          referredBy: this.member_id,
          referredByPhone: this.referal.referredByPhone
        })
        .then((refDoc) => {
          this.referals.push(this.referal)
          alert(` Code d'accès pour, ${this.referal.firstName} ${this.referal.lastName} ${this.referal.accessCode}`);
          this.referal.firstName = null,
            this.referal = {}
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    },
     saveChurchInfo () {
     const memberRef = db.collection("Census").doc(this.member_id);
      memberRef
        .update({
          churchName: this.form.churchName,
          churchAttendance: this.form.churchAttendance,
          memberSince: this.form.memberSince,
          sermonTimeSpent: parseInt(this.form.sermonTimeSpent),
          isreferralReady: this.form.isreferralReady,
          noReferralReason: this.form.noReferralReason,
          isVolunteerReady: this.form.isVolunteerReady,
          noVolunteerReason: this.form.noVolunteerReason,
          volunteerTime: this.form.volunteerTime,
        })
        .then(() => {
           this.alert = true;
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    },
    photoDialog() {
      this.$router.push("/appphoto");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/form/steppers/ChurchInfo.vue